import type { CartLine } from '@shopgnd/shared';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyClient = any;

export async function upsertCart(
  userId: string,
  email: string,
  lines: CartLine[],
  totalCents: number,
): Promise<void> {
  try {
    const { generateClient } = await import('aws-amplify/data');
    const client = generateClient() as AnyClient;
    const now = new Date().toISOString();
    const payload = {
      ownerUserId: userId,
      ownerEmail: email,
      lines: JSON.stringify(lines),
      totalCents,
      lastUpdatedAt: now,
    };
    const existing = await client.models.Cart.list({
      filter: { ownerUserId: { eq: userId } },
    });
    if ((existing.data ?? []).length > 0) {
      await client.models.Cart.update({ id: existing.data[0].id, ...payload });
    } else {
      await client.models.Cart.create(payload);
    }
  } catch (err) {
    console.warn('Cart sync failed:', err);
  }
}

export async function clearCart(userId: string): Promise<void> {
  try {
    const { generateClient } = await import('aws-amplify/data');
    const client = generateClient() as AnyClient;
    const existing = await client.models.Cart.list({
      filter: { ownerUserId: { eq: userId } },
    });
    for (const cart of existing.data ?? []) {
      await client.models.Cart.delete({ id: cart.id });
    }
  } catch (err) {
    console.warn('Cart clear failed:', err);
  }
}
